export const notificationLink = (item = {}) => {
  const link = `${item.deep_link || ''}`.trim();
  if (link.startsWith('/') && !link.startsWith('//') && !link.includes('\\')) return link;
  if (Number(item.work_item_id) > 0) return `/work-management/detail/${Number(item.work_item_id)}`;
  if (Number(item.order_id) > 0) return `/orders/detail/${Number(item.order_id)}?tab_active=information`;
  if (Number(item.task_detail_id) > 0) return `/task/detail/${Number(item.task_detail_id)}?currWFlow=${encodeURIComponent(item.task_work_flow_id || '')}`;
  if (item.notify_title?.includes('phép')) return '/off-work-add';
  return '';
};
